import { useStore } from "../store/store";
import { Setting } from "../store/store.types";
import { useCreateRecord } from "./useCreateRecord";
import { useUpdateRecord } from "./useUpdateRecord";
import { UseFormReturn } from "react-hook-form";

export const useSaveGridConfig = (entityForm: UseFormReturn) => {
    const updateSetting = useUpdateRecord({queryInvalidatePrefix: "settings"});
    const createSetting = useCreateRecord();
    const {
        gridSettings: { gridColumns, entity, selectedSettings, setGridSettings },
        progressFilter,
        modalFilter,
        recordsFilter,
        recordsSort,
    } = useStore();

    const saveConfig = async (nameValue?: string, isNew?: boolean) => {
        const settingsName = nameValue || selectedSettings?.name;
        if (!entity) return;

        if (!settingsName) {
            alert("Nome da configuração é obrigatório");
            return;
        }

        const config = gridColumns.map((gridColumn) => {
            return {
                field: gridColumn.field,
                headerName: gridColumn.headerName,
                visible: gridColumn.visible,
                width: gridColumn.width,
            };
        });

        const { isActive, id } = selectedSettings ?? {};
        
        const settingsModalFilter = modalFilter;
        const settingsProgressFilter = progressFilter;
        const settingsRecordsFilter = recordsFilter;
        const currentSort = recordsSort?.[entity] || null;

        const sharedRolesForAPI = entityForm.getValues("multiple_shared_roles");

        const settingsBody = {
            collection: entity,
            name: settingsName,
            isActive: isActive,
            config: {
                columns: config,
                filters: { modal: settingsModalFilter, progress: settingsProgressFilter, records: settingsRecordsFilter },
                sort: {
                    [entity]: currentSort,
                },
            },
            shared_roles: sharedRolesForAPI || [],
        };

        if (id && !isNew) {
            const response = (await updateSetting.mutateAsync({
                entity: "settings",
                id: id,
                data: settingsBody,
                fields: ["*", "shared_roles.*", "shared_roles.directus_roles_id.id", "shared_roles.directus_roles_id.name"],
            }, )) as Setting;

                setGridSettings({ selectedSettings: response});

            entityForm.setValue("multiple_shared_roles", {
                create: [],
                update: [],
                delete: [],
            });

        } else {
            const response = (await createSetting.mutateAsync({
                entity: "settings",
                data: settingsBody,
                fields: ["*", "shared_roles.*", "shared_roles.directus_roles_id.id", "shared_roles.directus_roles_id.name"],
            })) as Setting;

            setGridSettings({ selectedSettings: response });
        }
        setGridSettings({ configColumnsModalIsOpen: false });
    };

    return saveConfig;
};